import React from 'react';
import {
  Row,
  Col
} from 'antd';

type DescriptionItemProps = {
  title:string;
  content:any;
};

const DescriptionItem = ({ title, content }:DescriptionItemProps) => (
  <Row>
    <Col xs={24} sm={8} className="text-muted">
      {title}
    </Col>
    <Col xs={24} sm={8}>
      {content}
    </Col>
  </Row>
);

export default DescriptionItem;